module.exports = __webpack_public_path__ + "static/media/door03.b4d9a31e.png";